import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import VDCcomboLogo from '../assets/images/Logos.png';

export default function Login() {
     const [userCode, setUserCode] = useState('');
     const [password, setPassword] = useState('');
     const [error, setError] = useState('');
     const [isLoading, setIsLoading] = useState(false);
     const [showPassword, setShowPassword] = useState(false);

     const { login } = useAuth();

     const handleSubmit = async (e) => {
          e.preventDefault();
          setError('');
          // Basic validation
          if (!userCode.trim() || !password.trim()) {
               setError('Please enter both user code and password');
               return;
          }
          setIsLoading(true);
          try {
               const result = await login(userCode, password);

               if (!result.success) {
                    setError(result.error);
               }
               // If successful, the auth context will handle the state update
               // and the app will redirect to dashboard
          } catch (error) {
               setError('An unexpected error occurred. Please try again.');
          } finally {
               setIsLoading(false);
          }
     };

     return (
          <div className="container-fluid" style={{ height: '100vh', padding: 0 }}>
               <div className="row h-100">
                    {/* Left Column - Image/Branding */}
                    <div
                         className="col-lg-6 d-none d-lg-flex align-items-center justify-content-center"
                         style={{
                              background: "linear-gradient(135deg, #909499 0%, #34495e 50%, #2c3e50 100%)",
                              position: "relative",
                              minHeight: "100vh",
                              overflow: "hidden",
                         }}
                         aria-label="Branding and Info"
                    >
                         <div className="text-center text-white" style={{ zIndex: 2, width: "100%" }}>
                              <div
                                   className="mb-4 text-center"
                                   style={{
                                        maxWidth: "90%",
                                        height: "100px",
                                        backgroundColor: "rgba(238, 235, 235, 0.95)",
                                        padding: "1rem",
                                        borderRadius: "12px",
                                        boxShadow: "0 2px 16px rgba(44, 62, 80, 0.08)",
                                        margin: "0 auto",
                                   }}
                              >
                                   <img
                                        src={VDCcomboLogo}
                                        alt="VDC Healthcare"
                                        style={{ maxWidth: "80%", marginBottom: "2rem" }}
                                        loading="lazy"
                                   />
                              </div>
                              <h2 className="mb-4" style={{ fontWeight: 700, letterSpacing: "1px" }}>
                                   Radiology TLD  Management
                              </h2>
                              {/* <p
                                   className="lead mb-0"
                                   style={{ fontSize: "1.1rem", opacity: 0.92, fontWeight: 500 }}
                              >
                                   Professional Radiology Training &amp; Development Platform
                              </p>
                              <div className="mt-4">
                                   <p style={{ opacity: 0.85, fontSize: "1rem" }}>
                                        Secure access to your training dashboard
                                   </p>
                              </div> */}
                         </div>

                         {/* Decorative elements */}
                         <div
                              aria-hidden="true"
                              style={{
                                   position: "absolute",
                                   top: "10%",
                                   right: "10%",
                                   width: "100px",
                                   height: "100px",
                                   background: "rgba(255,255,255,0.12)",
                                   borderRadius: "50%",
                                   opacity: 0.5,
                                   zIndex: 1,
                                   filter: "blur(1px)",
                              }}
                         ></div>
                         <div
                              aria-hidden="true"
                              style={{
                                   position: "absolute",
                                   bottom: "15%",
                                   left: "15%",
                                   width: "60px",
                                   height: "60px",
                                   background: "rgba(255,255,255,0.12)",
                                   borderRadius: "50%",
                                   opacity: 0.7,
                                   zIndex: 1,
                                   filter: "blur(1px)",
                              }}
                         ></div>
                    </div>

                    {/* Right Column - Login Form */}
                    <div className="col-lg-6 d-flex align-items-center justify-content-center bg-light">
                         <div className="w-100" style={{ maxWidth: '400px', padding: '2rem' }}>
                              {/* Mobile Logo - Only shown on small screens */}
                              <div className="d-lg-none text-center mb-4">
                                   {/* <img
                                        src={VDCcomboLogo}
                                        alt="VDC Healthcare"
                                        style={{ height: '80px', maxWidth: '80%' }}
                                   /> */}
                              </div>

                              {/* <div className="text-center mb-4">
                                   <h3 className="mb-2" style={{ fontWeight: '600', color: '#2c3e50' }}>
                                        Welcome Back
                                   </h3>
                                   <p className="text-muted">
                                        Please sign in to your account
                                   </p>
                              </div> */}

                              {/* Error Alert */}
                              {error && (
                                   <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        <i className="fas fa-exclamation-triangle mr-2"></i>
                                        {error}
                                        <button
                                             type="button"
                                             className="close"
                                             onClick={() => setError('')}
                                        >
                                             <span>&times;</span>
                                        </button>
                                   </div>
                              )}

                              {/* Login Form */}
                              <form onSubmit={handleSubmit}>
                                   <div className="form-group mb-3">
                                        <label htmlFor="userCode" className="form-label" style={{ fontWeight: '500' }}>
                                             User Code
                                        </label>
                                        <div className="input-group">
                                             <div className="input-group-prepend">
                                                  <span className="input-group-text bg-white">
                                                       <i className="fas fa-user text-muted"></i>
                                                  </span>
                                             </div>
                                             <input
                                                  type="text"
                                                  id="userCode"
                                                  className="form-control"
                                                  placeholder="Enter your user code"
                                                  value={userCode}
                                                  onChange={(e) => setUserCode(e.target.value)}
                                                  required
                                                  disabled={isLoading}
                                                  style={{
                                                       border: '1px solid #e3e6f0',
                                                       borderLeft: 'none',
                                                       fontSize: '0.9rem'
                                                  }}
                                             />
                                        </div>
                                   </div>

                                   <div className="form-group mb-4">
                                        <label htmlFor="password" className="form-label" style={{ fontWeight: '500' }}>
                                             Password
                                        </label>
                                        <div className="input-group">
                                             <div className="input-group-prepend">
                                                  <span className="input-group-text bg-white">
                                                       <i className="fas fa-lock text-muted"></i>
                                                  </span>
                                             </div>
                                             <input
                                                  type={showPassword ? "text" : "password"}
                                                  id="password"
                                                  className="form-control"
                                                  placeholder="Enter your password"
                                                  value={password}
                                                  onChange={(e) => setPassword(e.target.value)}
                                                  required
                                                  disabled={isLoading}
                                                  style={{
                                                       border: '1px solid #e3e6f0',
                                                       borderLeft: 'none',
                                                       borderRight: 'none',
                                                       fontSize: '0.9rem'
                                                  }}
                                             />
                                             <div className="input-group-append">
                                                  <button
                                                       type="button"
                                                       className="btn btn-outline-secondary"
                                                       onClick={() => setShowPassword(!showPassword)}
                                                       disabled={isLoading}
                                                       style={{ border: '1px solid #e3e6f0', borderLeft: 'none' }}
                                                  >
                                                       <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                  </button>
                                             </div>
                                        </div>
                                   </div>

                                   {/* <div className="form-group mb-3">
                                        <div className="custom-control custom-checkbox">
                                             <input
                                                  type="checkbox"
                                                  className="custom-control-input"
                                                  id="rememberMe"
                                                  disabled={isLoading}
                                             />
                                             <label className="custom-control-label" htmlFor="rememberMe">
                                                  Remember me
                                             </label>
                                        </div>
                                   </div> */}

                                   <button
                                        type="submit"
                                        className="btn btn-block mb-3"
                                        disabled={isLoading}
                                        style={{
                                             background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
                                             border: 'none',
                                             color: 'white',
                                             padding: '0.75rem',
                                             fontWeight: '500',
                                             fontSize: '0.95rem'
                                        }}
                                   >
                                        {isLoading ? (
                                             <>
                                                  <span className="spinner-border spinner-border-sm mr-2" role="status">
                                                       <span className="sr-only">Loading...</span>
                                                  </span>
                                                  Logging In...
                                             </>
                                        ) : (
                                             <>
                                                  <i className="fas fa-sign-in-alt mr-2"></i>
                                                  Login
                                             </>
                                        )}
                                   </button>
                              </form>

                              {/* <div className="text-center">
                                   <button
                                        type="button"
                                        className="btn btn-link p-0 small text-muted"
                                        style={{ textDecoration: 'none', border: 'none', background: 'none' }}
                                        onClick={() => console.log('Forgot password clicked')}
                                   >
                                        Forgot Password?
                                   </button>
                              </div> */}

                              <div className="mt-4 text-center">
                                   <small className="text-muted">
                                        &copy; 2025 Vijaya Diagnostic Centre. All rights reserved.
                                   </small>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
}